<ng-container *ngIf="this.HasMenuData">
    <div style="visibility: hidden; position: fixed"
         [style.left]="this.ComponentContextMenuPositionX"
         [style.top]="this.ComponentContextMenuPositionY"
         [matMenuTriggerFor]="componentContextMenu"
         #itemContextMenuTrigger>
    </div>
    <mat-menu #componentContextMenu="matMenu">
        <!--
    10-21-2022 to do:  1. Handle the menus without submenus in a separate *ngFor loop from the menus with submenus;
                       2. Handle the menus with submenus as menuWithSubmenus_1, menuWithSubmenus_2, etc.;
                       3. Use a *switchcase to handle menuWithSubmenus_1, menuWithSubmenus_2, etc.;
                       4. Below define the submenus for menuWithSubmenus_1, menuWithSubmenus_2, etc.;
    -->
        <!-- 1. Handle menus without submenus. -->
        <ng-container *ngIf="this.ExistsAnyMenuWithoutSubmenus">
            <ng-container *ngFor="let menuData of this.MenuDataWithoutSubmenus; let i=index">
                <ng-container *ngIf="menuData.DisplayMenuItem">
                    <ng-container *ngIf="menuData.IsMenuDivider">
                        <mat-divider></mat-divider>
                    </ng-container>

                    <ng-container *ngIf="!menuData.IsMenuDivider">
                        <button mat-menu-item
                                [disabled]="menuData.MenuItemDisabled"
                                (click)="this.menuItemClicked(menuData, $event)">
                            {{menuData.menuItemTitle}}
                        </button>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>


        <!-- 2. Handle menus without submenus. -->
        <ng-container *ngIf="this.ExistsAnyMenuWithSubmenus">
            <ng-container *ngFor="let menuData of this.MenuDataWithSubmenus; let i=index">
                <ng-container [ngSwitch]="i">
                    <ng-container *ngSwitchCase="0">
                        <button mat-menu-item [matMenuTriggerFor]="submenu_0">
                            {{menuData.menuItemTitle}}
                        </button>
                    </ng-container>

                    <ng-container *ngSwitchCase="1">
                        <button mat-menu-item [matMenuTriggerFor]="submenu_1">
                            {{menuData.menuItemTitle}}
                        </button>
                    </ng-container>

                </ng-container>
            </ng-container>

            <!-- Note:  we will need to create #submenu_2, #submenu_3, ... if we have large primary menus with submenus. -->
            <mat-menu #submenu_0="matMenu">
                <ng-container *ngIf="this.ExistsMenuWithSubmenus(0)">
                    <ng-container *ngFor="let submenuData of this.MenuSubmenus(0)">
                        <button mat-menu-item
                                [disabled]="submenuData.MenuItemDisabled"
                                (click)="this.menuItemClicked(submenuData, $event)">
                            {{submenuData.menuItemTitle}}
                        </button>
                    </ng-container>
                </ng-container>
            </mat-menu>

            <mat-menu #submenu_1="matMenu">
                <ng-container *ngIf="this.ExistsMenuWithSubmenus(1)">
                    <ng-container *ngFor="let submenuData of this.MenuSubmenus(1)">
                        <button mat-menu-item
                                [disabled]="submenuData.MenuItemDisabled"
                                (click)="this.menuItemClicked(submenuData, $event)">
                            {{submenuData.menuItemTitle}}
                        </button>
                    </ng-container>
                </ng-container>
            </mat-menu>

        </ng-container>

    </mat-menu>
</ng-container>
